import styles from '@features/voucher-new/styles/voucher-new.module.css';
import React from 'react';

import { useResponsive } from '@shared/hooks/useResponsive';
import { ImageList } from '@shared/config/constants/Images';
import { VoucherNewForm } from '@features/voucher-new/ui/components/VoucherNewForm';
import { VoucherFooter } from '@features/voucher-new/ui/components/VoucherFooter';
import { VoucherHeader } from '@features/voucher-new/ui/components/VoucherHeader';
import { useTranslation } from 'react-i18next';

export const VoucherNew = () => {
  const { t } = useTranslation();
  const [isMobile] = useResponsive('MOBILE');

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <VoucherHeader />

          {isMobile ? (
            <img
              src={ImageList.voucher_new_mob}
              alt="banner"
              className={styles.voucherBannerClassname}
            />
          ) : (
            <img
              src={ImageList.voucher_new_desk}
              alt="banner"
              className={styles.voucherBannerClassname}
            />
          )}

          <p className={styles.voucherBannerText}>{t('voucher_banner_title')}</p>

          <VoucherNewForm />
        </div>

        <VoucherFooter />
      </div>
    </div>
  );
};
